import React from 'react';
import iconDoubleCheckBlue from "../images/doublecheckblue_64.png";
import iconDoubleCheckGray from "../images/doublecheckgray_64.png";

function MsgViewed(props){
    return (props.viewed ? <img src={iconDoubleCheckBlue} alt="vv" width="16" hspace="5" /> : <img src={iconDoubleCheckGray} alt="v" width="16" hspace="5" />);
}

export default MsgViewed;